const USER_PROFILE_ACTIONS = {
  GET_USER_INFO_SUCCESS: 'USER_PROFILE/GET_USER_INFO_SUCCESS',
  UPDATE_USER_INFO: 'USER_PROFILE/UPDATE_USER_INFO',
  TOGGLE_PROFILE_PANEL: 'USER_PROFILE/TOGGLE_PROFILE_PANEL'
}

export default USER_PROFILE_ACTIONS

export const  FT_DEL_ACC = 'ft_del_acc'
export const  DEL_ACC = 'del_acc'